import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlertComponent, PlessAlert } from './../../../shared/pless-alert/pless-alert.component';
import { KYMW1104OutputModel } from '../kymw1100/vo/kymw1104-output.model';
import { GetSelectedCodesForCoopsService } from './api-services/get-selected-codes-for-coops.service';
import { InitItemCodeComboService } from './api-services/init-item-code-combo.service';
import { KYMW1104InputModel } from '../kymw1100/vo/kymw1104-input.model';
import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1104Model } from './kymw1104.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { UpdateItemCodeForCoopService } from './api-services/update-item-code-for-coop.service';

/**
 * アイテム付替画面を管理するクラス
 *
 * @export KYMW1104Component
 * @class KYMW1104Component
 */
@Component({
  selector: 'app-kymw1104',
  templateUrl: 'kymw1104.component.html',
  styleUrls: ['kymw1104.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1104Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw1104Model: KYMW1104Model = new KYMW1104Model();

  public setKYMW1104Parameter: Function;

  @ViewChild('cmb_IbarakiItemCode', { static: true }) cmb_IbarakiItemCode: ElementRef;
  @ViewChild('cmb_TochigiItemCode', { static: true }) cmb_TochigiItemCode: ElementRef;
  @ViewChild('cmb_GunmaItemCode', { static: true }) cmb_GunmaItemCode: ElementRef;
  @ViewChild('cmb_ChibaItemCode', { static: true }) cmb_ChibaItemCode: ElementRef;
  @ViewChild('cmb_SaitamaItemCode', { static: true }) cmb_SaitamaItemCode: ElementRef;
  @ViewChild('cmb_TokyoItemCode', { static: true }) cmb_TokyoItemCode: ElementRef;
  @ViewChild('cmb_NaganoItemCode', { static: true }) cmb_NaganoItemCode: ElementRef;
  @ViewChild('cmb_NiigataItemCode', { static: true }) cmb_NiigataItemCode: ElementRef;

  @ViewChild('btn_SetItem', { static: true }) btn_SetItem: ElementRef;
  @ViewChild('btn_CloseWindow', { static: true }) btn_CloseWindow: ElementRef;

  /**
   * 親画面の情報を保存する。
   */
  private inputVo: KYMW1104InputModel;

  // 商品マスタの画面で編集カウントを保存する。
  private editFlag: boolean = <boolean>false;

  // 会員生協のコンボボックスの編集Flag
  private ibarakiItemCodeFlag: boolean = <boolean>false;
  private tochigiItemCodeFlag: boolean = <boolean>false;
  private gunmaItemCodeFlag: boolean = <boolean>false;
  private chibaItemCodeFlag: boolean = <boolean>false;
  private saitamaItemCodeFlag: boolean = <boolean>false;
  private tokyoItemCodeFlag: boolean = <boolean>false;
  private naganoItemCodeFlag: boolean = <boolean>false;
  private niigataItemCodeFlag: boolean = <boolean>false;

  /**
   * Creates an instance of KYMW1104Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1104Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public getSelectedCodesForCoopsService: GetSelectedCodesForCoopsService,
    public initItemCodeComboService: InitItemCodeComboService,
    public updateItemCodeForCoopService: UpdateItemCodeForCoopService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1104Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1104';
    // 受け渡し情報がなければ以降の表示設定は行わない
    if (this.inputVo === null) {
      return;
    }
    this.kymw1104Model.kymw1104Component = this;

    this.kymw1104Model.pCode = this.inputVo.pCode;
    this.kymw1104Model.guideGoodsName = this.inputVo.guideGoodsName;
    this.kymw1104Model.guideStandardName = this.inputVo.guideStandardName;

    this.editFlag = this.inputVo.goodsMasterEditFlag;
    const pCode: string = this.kymw1104Model.pCode;

    // アイテムコンボボックス設定取得
    this.initItemCodeComboService.execute(this.kymw1104Model, pCode);
  }

  public setInterfaceParam(param: any) {
    // 受渡情報の設定
    this.inputVo = <KYMW1104InputModel>param;
  }

  /**
   * ComboBoxChangeタンイベント
   *
   * @param event 選択時イベント
   */
  public eventItemCode_CHANGEHandler(event: any): void {
    // 編集されたかどうか判断する。
    if (event.target.id === 'cmb_IbarakiItemCode') {
      if (this.kymw1104Model.ibaraki_ItemCode !== this.kymw1104Model.ibarakiItemCode) {
        this.ibarakiItemCodeFlag = true;
      } else {
        this.ibarakiItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_TochigiItemCode') {
      if (this.kymw1104Model.tochigi_ItemCode !== this.kymw1104Model.tochigiItemCode) {
        this.tochigiItemCodeFlag = true;
      } else {
        this.tochigiItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_GunmaItemCode') {
      if (this.kymw1104Model.gunma_ItemCode !== this.kymw1104Model.gunmaItemCode) {
        this.gunmaItemCodeFlag = true;
      } else {
        this.gunmaItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_ChibaItemCode') {
      if (this.kymw1104Model.chiba_ItemCode !== this.kymw1104Model.chibaItemCode) {
        this.chibaItemCodeFlag = true;
      } else {
        this.chibaItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_SaitamaItemCode') {
      if (this.kymw1104Model.saitama_ItemCode !== this.kymw1104Model.saitamaItemCode) {
        this.saitamaItemCodeFlag = true;
      } else {
        this.saitamaItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_TokyoItemCode') {
      if (this.kymw1104Model.tokyo_ItemCode !== this.kymw1104Model.tokyoItemCode) {
        this.tokyoItemCodeFlag = true;
      } else {
        this.tokyoItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_NaganoItemCode') {
      if (this.kymw1104Model.nagano_ItemCode !== this.kymw1104Model.naganoItemCode) {
        this.naganoItemCodeFlag = true;
      } else {
        this.naganoItemCodeFlag = false;
      }
    } else if (event.target.id === 'cmb_NiigataItemCode') {
      if (this.kymw1104Model.niigata_ItemCode !== this.kymw1104Model.niigataItemCode) {
        this.niigataItemCodeFlag = true;
      } else {
        this.niigataItemCodeFlag = false;
      }
    }

    // 設定ボタンの活性、非活性制御を行う。
    if (this.ibarakiItemCodeFlag
      || this.tochigiItemCodeFlag
      || this.gunmaItemCodeFlag
      || this.chibaItemCodeFlag
      || this.saitamaItemCodeFlag
      || this.tokyoItemCodeFlag
      || this.naganoItemCodeFlag
      || this.niigataItemCodeFlag) {
      this.kymw1104Model.enabledSetItem = true;
    } else {
      this.kymw1104Model.enabledSetItem = false;
    }
  }

  /**
   * 設定ボタンイベント
   *
   * @param event 選択時イベント
   */
  public eventSetItem_CLICKHandler(event: Event): void {
    // 親画面で編集かあったかどうか判断する。
    if (this.editFlag) {
      this.dialogService.openAlertGetMessage('Q0107', ['商品情報'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          this.setItem_Click();
        }
      });
    } else {
      this.dialogService.openAlertGetMessage('Q0108', ['会員生協のアイテムコード'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          this.setItem_Click();
        }
      });
    }
  }

  /**
   * 「設定」実行
   */
  public setItem_Click(): void {
    const tempItemCode: Array<any> = new Array<any>();
    const ibaraki: any = new Object();
    const tochigi: any = new Object();
    const gunma: any = new Object();
    const chiba: any = new Object();
    const saitama: any = new Object();
    const tokyo: any = new Object();
    const nagano: any = new Object();
    const niigata: any = new Object();

    let count: number = <number>0;

    // 会員生協が編集されたものを保全する。
    if (this.ibarakiItemCodeFlag) {
      ibaraki.CoopCode = this.kymw00Model.COOP_CODE_IB;
      ibaraki.ItemCode = this.kymw1104Model.ibaraki_ItemCode;
      tempItemCode.push(ibaraki);
      count++;
    }
    if (this.tochigiItemCodeFlag) {
      tochigi.CoopCode = this.kymw00Model.COOP_CODE_TO;
      tochigi.ItemCode = this.kymw1104Model.tochigi_ItemCode;
      tempItemCode.push(tochigi);
      count++;
    }
    if (this.gunmaItemCodeFlag) {
      gunma.CoopCode = this.kymw00Model.COOP_CODE_GU;
      gunma.ItemCode = this.kymw1104Model.gunma_ItemCode;
      tempItemCode.push(gunma);
      count++;
    }
    if (this.chibaItemCodeFlag) {
      chiba.CoopCode = this.kymw00Model.COOP_CODE_TI;
      chiba.ItemCode = this.kymw1104Model.chiba_ItemCode;
      tempItemCode.push(chiba);
      count++;
    }
    if (this.saitamaItemCodeFlag) {
      saitama.CoopCode = this.kymw00Model.COOP_CODE_SA;
      saitama.ItemCode = this.kymw1104Model.saitama_ItemCode;
      tempItemCode.push(saitama);
      count++;
    }
    if (this.tokyoItemCodeFlag) {
      tokyo.CoopCode = this.kymw00Model.COOP_CODE_TK;
      tokyo.ItemCode = this.kymw1104Model.tokyo_ItemCode;
      tempItemCode.push(tokyo);
      count++;
    }
    if (this.naganoItemCodeFlag) {
      nagano.CoopCode = this.kymw00Model.COOP_CODE_NA;
      nagano.ItemCode = this.kymw1104Model.nagano_ItemCode;
      tempItemCode.push(nagano);
      count++;
    }
    if (this.niigataItemCodeFlag) {
      niigata.CoopCode = this.kymw00Model.COOP_CODE_NI;
      niigata.ItemCode = this.kymw1104Model.niigata_ItemCode;
      tempItemCode.push(niigata);
      count++;
    }

    const vo = {
      pCode: this.kymw1104Model.pCode,
      itemCodeList: tempItemCode
    };

    // 会員生協の更新を行う。
    this.updateItemCodeForCoopService.execute(this.kymw1104Model, vo);

  }

  /**
   * 親画面に戻す
   */
  public reloadKYMW1104(): void {
    const outputVO: KYMW1104OutputModel = new KYMW1104OutputModel();

    this.setKYMW1104Parameter(outputVO);

    // アイテム付替画面を閉じる
    this.onClickClose();
  }
}
